const filters = Vue => {
    /**
     * 日期过滤
     * 将时间戳转换成日期字符串，默认到秒
     * {{时间戳 | dateFormat}}
     * {{时间戳 | dateFormat('YYYY年MM月DD日')}}
     */
    Vue.filter('dateFormat', (value, formatStr = "YYYY-MM-DD HH:mm:ss") => {
        if (value) {
            let len = "" + value;
            len = len.split("");
            if (len.length < 13) {
                value = value * 1000;
            }
        }
        return Vue.prototype.$moment(value).format(formatStr);
    })
}


export default filters;
